import { Box, Modal } from '@mui/material';
import AskRachelButton from './components/AskRachelButton';
import GlobalSearchBody from './components/GlobalSearchBody';
import SearchBar from './components/SearchBar/SearchBar';
import useGlobalSearchModal from './hooks/useGlobalSearchModal';

const MODAL_WIDTH = 640;
const MODAL_WIDTH_SM = 540;
const MODAL_TOP_OFFSET = 40;
const MODAL_MAX_HEIGHT = 664;
const MODAL_VIEWPORT_MARGIN = 104;

interface GlobalSearchModalProps {
  isOpen: boolean;
  onClose: () => void;
}

function GlobalSearchModal({ isOpen, onClose }: GlobalSearchModalProps) {
  const { view, onKeyDown, search, recents, suggestedCatalogs, results, warning } =
    useGlobalSearchModal({ isOpen, onClose });

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box
        role="dialog"
        aria-modal
        aria-label={results.ariaLabel}
        test-id="global-search-modal"
        tabIndex={-1}
        onKeyDown={onKeyDown}
        sx={(theme) => ({
          position: 'fixed',
          boxSizing: 'border-box',
          top: MODAL_TOP_OFFSET,
          left: '50%',
          transform: 'translateX(-50%)',
          width: MODAL_WIDTH,
          maxWidth: `calc(100vw - ${theme.spacing(4)})`,
          maxHeight: `min(${MODAL_MAX_HEIGHT}px, calc(100vh - ${MODAL_VIEWPORT_MARGIN}px))`,
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
          p: 1,
          backgroundColor: theme.palette.background.paper,
          borderRadius: `${theme.shape.borderRadiusXl}px`,
          boxShadow: `${theme.shadows[16]}, inset 0 0 0 0.5px ${theme.palette.divider}`,
          overflow: 'clip',
          '&:focus-visible': { outline: 'none' },
          [theme.breakpoints.only('sm')]: {
            width: MODAL_WIDTH_SM,
          },
          [theme.breakpoints.down('sm')]: {
            top: 0,
            left: 0,
            transform: 'none',
            width: '100vw',
            maxWidth: '100vw',
            height: '100dvh',
            maxHeight: '100dvh',
            borderRadius: 0,
            boxShadow: 'none',
          },
        })}
      >
        <SearchBar
          {...search}
          testId="global-search-input"
          onBack={results.isMobile ? onClose : undefined}
          askRachelSlot={
            <AskRachelButton
              term={search.value}
              activeEntityLabel={results.activeEntityLabel}
              onClose={onClose}
            />
          }
        />
        <GlobalSearchBody
          view={view}
          warning={warning}
          recents={recents}
          suggestedCatalogs={suggestedCatalogs}
          results={results}
        />
      </Box>
    </Modal>
  );
}

export default GlobalSearchModal;
